import React, {
  useEffect,
  useState,
} from "react";

import { createPortal } from "react-dom";

import "./PopupQuestion.css";

import conti from "../imagesHome/conti.png";
import coinImg from "../header/images/coin.png";

const CLOSE_ANIMATION_DURATION = 280;

const PopupQuestion = ({
  quizExplanation,
  coinCount = 0,
  onRevealAnswer,
  onSpendCoins,
}) => {
  const [isVisible, setIsVisible] =
    useState(false);

  const [isOpen, setIsOpen] =
    useState(false);

  const [showExplanation, setShowExplanation] =
    useState(false);

  const [
    explanationPurchased,
    setExplanationPurchased,
  ] = useState(false);

  const [answerRevealed, setAnswerRevealed] =
    useState(false);

  const [
    unlockingExplanation,
    setUnlockingExplanation,
  ] = useState(false);

  const [
    unlockingAnswer,
    setUnlockingAnswer,
  ] = useState(false);

  const openPopup = () => {
    if (isVisible || isOpen) {
      return;
    }

    setIsVisible(true);

    requestAnimationFrame(() => {
      setIsOpen(true);
    });
  };

  const closePopup = () => {
    if (!isVisible) {
      return;
    }

    setIsOpen(false);
    setShowExplanation(explanationPurchased);
  };

  const handleBack = () => {
    setUnlockingExplanation(false);
    setUnlockingAnswer(false);
  };

  const handleShowExplanation = () => {
    if (coinCount < 20) {
      setUnlockingExplanation("insufficient");
      return;
    }

    setUnlockingExplanation(true);
  };

  const handleExplanationUnlock = () => {
    setUnlockingExplanation(false);
    setExplanationPurchased(true);
    setShowExplanation(true);

    onSpendCoins?.(20);
  };

  const handleOpenAnswerPurchase = () => {
    if (coinCount < 30) {
      setUnlockingAnswer("insufficient");
      return;
    }

    setUnlockingAnswer(true);
  };

  const handleConfirmAnswer = () => {
    setAnswerRevealed(true);
    setShowExplanation(true);
    setUnlockingAnswer(false);

    onSpendCoins?.(30);
    onRevealAnswer?.();

    closePopup();
  };

  /*
   * Reset la schimbarea intrebarii.
   */
  useEffect(() => {
    setIsVisible(false);
    setIsOpen(false);
    setShowExplanation(false);
    setExplanationPurchased(false);
    setAnswerRevealed(false);
    setUnlockingExplanation(false);
    setUnlockingAnswer(false);
  }, [quizExplanation]);

  /*
   * Pastreaza componenta montata pana cand
   * animatia de inchidere este terminata.
   */
  useEffect(() => {
    if (!isVisible || isOpen) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setIsVisible(false);
    }, CLOSE_ANIMATION_DURATION);

    return () => {
      window.clearTimeout(timer);
    };
  }, [isVisible, isOpen]);

  /*
   * Reseteaza starile temporare dupa
   * disparitia completa a popup-ului.
   */
  useEffect(() => {
    if (isVisible) {
      return;
    }

    setAnswerRevealed(false);
    setUnlockingExplanation(false);
    setUnlockingAnswer(false);
  }, [isVisible]);

  /*
   * Blocheaza scrollul si interactiunea
   * cu pagina din spate.
   */
  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const previousBodyOverflow =
      document.body.style.overflow;

    const previousHtmlOverflow =
      document.documentElement.style.overflow;

    const previousBodyPaddingRight =
      document.body.style.paddingRight;

    const scrollbarWidth =
      window.innerWidth -
      document.documentElement.clientWidth;

    document.body.classList.add(
      "quiz-active"
    );

    document.documentElement.classList.add(
      "quiz-active"
    );

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow =
      "hidden";

    if (scrollbarWidth > 0) {
      document.body.style.paddingRight =
        `${scrollbarWidth}px`;
    }

    return () => {
      document.body.classList.remove(
        "quiz-active"
      );

      document.documentElement.classList.remove(
        "quiz-active"
      );

      document.body.style.overflow =
        previousBodyOverflow;

      document.documentElement.style.overflow =
        previousHtmlOverflow;

      document.body.style.paddingRight =
        previousBodyPaddingRight;
    };
  }, [isVisible]);

  /*
   * Inchidere cu Escape.
   */
  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key !== "Escape") {
        return;
      }

      if (
        unlockingExplanation ||
        unlockingAnswer
      ) {
        handleBack();
        return;
      }

      closePopup();
    };

    document.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () => {
      document.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [
    isVisible,
    unlockingExplanation,
    unlockingAnswer,
  ]);

  const renderCoinsInfo = () => (
    <div className="popup-question-coins-info">
      <img
        src={coinImg}
        className="popup-coin-icon"
        alt="Monede"
      />

      <span>Sold: {coinCount}</span>
    </div>
  );

  const renderMascotMessage = (content) => (
    <div className="popup-question-mascot">
      <img
        src={conti}
        className="popup-question-conti"
        alt="Conti"
      />

      <div className="popup-question-bubble">
        {content}
      </div>
    </div>
  );

  const renderAckButton = () => (
    <div className="popup-question-btns">
      <button
        type="button"
        className={[
          "popup-question-btn",
          "popup-question-btn--ack",
        ].join(" ")}
        onClick={closePopup}
      >
        <span className="popup-question-btn-label">
          Am inteles
        </span>
      </button>
    </div>
  );

  const renderPopupContent = () => {
    if (
      unlockingAnswer === "insufficient"
    ) {
      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <p>
              Nu ai suficiente monede pentru a
              cumpara raspunsul.
            </p>
          )}

          {renderAckButton()}
        </>
      );
    }

    if (unlockingAnswer) {
      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <p>
              Raspunsul costa{" "}
              <strong>30 monede</strong>.
              Doresti sa il cumperi?
            </p>
          )}

          <div className="popup-question-btns">
            <button
              type="button"
              className={[
                "popup-question-btn",
                "popup-question-btn--answer",
              ].join(" ")}
              onClick={handleConfirmAnswer}
            >
              <span className="popup-question-btn-label">
                Cumpara
              </span>
            </button>
          </div>
        </>
      );
    }

    if (
      unlockingExplanation ===
      "insufficient"
    ) {
      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <p>
              Nu ai suficiente monede pentru a
              cumpara explicatia.
            </p>
          )}

          {renderAckButton()}
        </>
      );
    }

    if (unlockingExplanation) {
      return (
        <>
          {renderCoinsInfo()}

          {renderMascotMessage(
            <p>
              Explicatia costa{" "}
              <strong>20 monede</strong>.
              Doresti sa o cumperi?
            </p>
          )}

          <div className="popup-question-btns">
            <button
              type="button"
              className={[
                "popup-question-btn",
                "popup-question-btn--answer",
              ].join(" ")}
              onClick={
                handleExplanationUnlock
              }
            >
              <span className="popup-question-btn-label">
                Cumpara
              </span>
            </button>
          </div>
        </>
      );
    }

    return (
      <>
        {renderCoinsInfo()}

        {renderMascotMessage(
          showExplanation ? (
            <div
              className="popup-question-explanation-content"
              dangerouslySetInnerHTML={{
                __html:
                  quizExplanation ||
                  "<p>Explicatia nu este disponibila pentru acest quiz.</p>",
              }}
            />
          ) : (
            <p>Ai ramas blocat?</p>
          )
        )}

        <div className="popup-question-btns">
          {!answerRevealed &&
            !showExplanation && (
              <>
                <button
                  type="button"
                  className={[
                    "popup-question-btn",
                    "popup-question-btn--hint",
                  ].join(" ")}
                  onClick={
                    handleShowExplanation
                  }
                >
                  <span className="popup-question-btn-label">
                    Vezi explicatia
                  </span>
                </button>

                <div className="popup-question-or">
                  sau
                </div>

                <button
                  type="button"
                  className={[
                    "popup-question-btn",
                    "popup-question-btn--answer",
                  ].join(" ")}
                  onClick={
                    handleOpenAnswerPurchase
                  }
                >
                  <span className="popup-question-btn-label">
                    Vezi raspunsul
                  </span>
                </button>
              </>
            )}

          {!answerRevealed &&
            showExplanation && (
              <>
                <button
                  type="button"
                  className="popup-question-subtle-answer-btn"
                  onClick={
                    handleOpenAnswerPurchase
                  }
                >
                  Nu este suficient de clar?
                  Poti cumpara raspunsul
                </button>

                <button
                  type="button"
                  className={[
                    "popup-question-btn",
                    "popup-question-btn--ack",
                  ].join(" ")}
                  onClick={closePopup}
                >
                  <span className="popup-question-btn-label">
                    Am inteles
                  </span>
                </button>
              </>
            )}
        </div>
      </>
    );
  };

  const popup =
    isVisible &&
    typeof document !== "undefined"
      ? createPortal(
          <>
            <div
              className={[
                "popup-question-overlay",
                isOpen ? "open" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={closePopup}
              aria-hidden="true"
            />

            <div
              className={[
                "popup-question",
                isOpen ? "open" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              role="dialog"
              aria-modal="true"
              aria-label="Ajutor pentru lectie"
            >
              <button
                type="button"
                className={[
                  "popup-question-close",
                  unlockingExplanation ||
                  unlockingAnswer
                    ? "popup-question-close--text"
                    : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
                onClick={
                  unlockingExplanation ||
                  unlockingAnswer
                    ? handleBack
                    : closePopup
                }
                aria-label={
                  unlockingExplanation ||
                  unlockingAnswer
                    ? "Inapoi"
                    : "Inchide"
                }
              >
                {unlockingExplanation ||
                unlockingAnswer
                  ? "Inapoi"
                  : "×"}
              </button>

              <div className="popup-question-content">
                {renderPopupContent()}
              </div>
            </div>
          </>,
          document.body
        )
      : null;

  return (
    <>
      <div className="popup-question-container">
        <button
          type="button"
          className="oriented-question-track"
          onClick={
            isOpen
              ? closePopup
              : openPopup
          }
          aria-label="Deschide ajutor"
          aria-expanded={isOpen}
        >
          <span className="help-icon">
            ?
          </span>

          <span className="help-text">
            HELP
          </span>
        </button>
      </div>

      {popup}
    </>
  );
};

export default PopupQuestion;